import elementResizeDetectorMaker from "element-resize-detector"; // 盒子大小监听插件
import { getTenantId } from "@/utils/authStore";
import {
  deepCopy
} from "@/utils/deepCopy.js";
import {
  validateEmail
} from "@/utils/validate";
import {
  getEnumMetaData,
  getEnumMetaValue
} from "@/utils/getEnumMeta";
import {
  getCompanyStoreSettings,
  getTenantSettings
} from "@/http/api/system";
import {
  getCompanyStoreDetail,
  updateCompanyStore,
  updateStatus,
  changeCompany,
  bindingStoreUser
} from "@/http/api/companyStore";
import {
  getByTagOrgs,
} from "@/http/api/organization";
import {
  getCompaniesSearch,
} from "@/http/api/company";
import {
  getUsersSearch
} from "@/http/api/employe";
export default {
  data() {
    
    var checkPhone = (rule, value, callback) => {console.log(value,"value");
      const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
      if(value===null||value===""){
        callback()
      }else if (!Number.isInteger(+value)) {
        callback(new Error('请输入数字值'))
      } else {
        if (phoneReg.test(value)) {
          callback()
        } else {
          callback(new Error('电话号码格式不正确'))
        }
      }
    };
    var validateFormEmail = (rule, value, callback) => {console.log(value,"value");
      if (value === '') {
        callback();
      } else if (!validateEmail(value)) {
        callback(new Error('邮箱格式不正确'));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      headerText: "分销商门店",
      isScrollShow: false, // 头部滚动内容显示
      isHeaderInit: false,
      isHeaderShadow: false, // 头部阴影显示
      isHeaderVisible: false, // 滚动头部显示
      isTagsShow: true, // 标签/输入框显示
      isRemarkShow: false, // 标签备注窗口显示

      //远程搜索下拉框
      orgList: [],
      getOrgLoading: false,
      companyList: [],
      getCompanyLoading: false,
      userList: [],
      getUserLoading: false,

      companyStore: {
        status: '', //状态
        name: '', //名称
        alias: '', //简称
        email: '', //邮箱
        phoneNumber: '', //手机号
        registerAddress: '', //工商注册地址
        currentAddress: '', //实际经营地址
        businessLicense: '', //营业执照号码
        totalMembers: '', //目标店数
        recruitWay: '', //加盟渠道来源
        nature: '', //公司性质
        hasQualifications: '', //是否有房地产经纪资质
        owner: '', //公司法人
        ownerPhoneNumber: '', //公司法人联系电话
        ownerCardType: '', //公司法人证件类型
        ownerCardNumber: '', //公司法人证件号码
        more: '', //备注
        type: '', //分销商门店类型
        tags: [], //标签
      },
      companyStoreRules: {
        companyId: [{
          required: true,
          message: '请选择分销商',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入分销商门店名称',
          trigger: 'blur'
        }],
        email: [{
          required: false,
          validator: validateFormEmail,
          trigger: 'blur'
        }],
        phoneNumber: [ {
          required: false,
          validator: checkPhone,
          trigger: 'blur'
        }],
        organizationId:[
          {
            required: true,
            message: '请选择组织',
            trigger: 'change'
          }
        ]
      },
      //标签
      tagNum: 3,
      headTag: '',
      isTagChange: false,
      // 备注表单
      remarkForm: {
        more: "",
      },
      isRemarkChange: false,
      //头像
      isLoading: false,
      // 选项
      companyNatureOptions: [], //公司性质
      recruitWayOptions: [], //渠道来源
      companyStorePayMentOptions: [], //分销商门店支付方式
      companyStoreTypeOptions: [], //分销商门店类型
      companyStoreStatusOptions: [], //分销商门店状态
      companyStoreDropWayOptions: [], //分销商门店退出方式
      // 证件类型
      ownerCardTypeOptions: [{
        option: '大陆身份证',
      }, {
        option: '军官证',
      }, {
        option: '港台身份证',
      }, {
        option: '护照',
      }, {
        option: '驾驶证',
      }, {
        option: '其他',
      }],
      isEditBasic: false,
      isEditDetail: false,
      isEditCharge: false,
      isEditUser: false,
      isEditCompany: false,
      isEditStatus: false,
      //隐藏数字信息
      hideInfo: {
        headerPhone: true,
        phoneNumber: true,
        ownerPhoneNumber: true
      },
      permissions: this.$store.getters.permissions,

      isTransferBroker:false
    }
  },
  mounted() {
    this.getUser('');
    this.getCompany();
    this.getTenantSettings();
    this.getCompanyStoreDetail(); //获取详情
    this.getCompanyStoreSettings(); //获取分销商门店设置
    //分销商门店类型
    this.companyStoreTypeOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyStoreType');
    //分销商门店状态
    this.companyStoreStatusOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyStoreStatus');
    //分销商门店支付类型
    this.companyStorePayMentOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyStorePaymentType');

    //监听滚动
    let el = document.querySelector(".edit-employe");
    el.addEventListener("scroll", this.scrollScreen);
    if (!this.isHeaderInit) {
      this.erd = elementResizeDetectorMaker();
      this.erd.listenTo(el, this.headerInit);
      this.headerInit();
    }
  },
  methods: {
    // 更新分销商门店状态
    changeStatus() {
      updateStatus(this.$route.params.id, {
        status: this.companyStore.status
      }).then(res => {
        this.getEnumValue(res); //设置默认字段显示值
        this.companyStore.status = res.result.status;
        this.companyStore.statusVal = res.result.statusVal;
        this.isEditStatus = false;
        if (res) {
          this.$message.success({
            message: "修改分销商门店状态成功",
            showClose: true
          });
        }
      });
    },
    // 更新分销商-分销商门店
    changeCompany(companyId) {
      changeCompany(this.$route.params.id, companyId).then(res => {
        this.$set(this.companyStore, 'companyId', res.result.companyId);
        this.isEditCompany = false;
        if (res) {
          this.getCompanyStoreDetail()
          this.$message.success({
            message: "修改分销商成功",
            showClose: true
          });
        }
      });
    },
    getTenantSettings(){
      getTenantSettings({ __tenant: getTenantId() }).then(res=>{
        this.isTransferBroker = res.result.find(item => item.name == 'Deer.Tenant.Value.EnableTransferCompanyStoreWithBroker').value;
      });
    },
    // 更新分销商门店-负责人
    changeUser(userId) {
      if (userId) {
        var params = {
          userId: userId,
          companyStoreIds: [this.$route.params.id],
          isChangeBroker: this.isTransferBroker
        };
        bindingStoreUser(params).then(res => {
          this.isEditUser = false;
          if (res) {
            this.getCompanyStoreDetail()
            this.$message.success({
              message: "修改分销商门店负责人成功",
              showClose: true
            });
          }
        });
      } else {
        this.$message({
          message: "请选择负责人",
          showClose: true
        });
      }
    },
    // 获取组织机构
    getOrganization(e) {
      this.getOrgLoading = true;
      let query = {
        tag: '店',
        Filter: e,
        PermissionFilter : true,
        maxResultCount: 1000,
      }
      getByTagOrgs(query).then((res) => {
        this.getOrgLoading = false;
        this.orgList = res.result.items;
      }).catch(err => {
        this.getOrgLoading = false
      });
    },
    // 获取负责人
    getUser(e) {
      this.getUserLoading = true;
      var params = {
        changeType: "",
        changeReviewStatus: "",
        isWorkingUser: null,
        filter: e,
        posts: ["渠道经理"],
        timeCondition: "",
        startTime: "",
        endTime: "",
        status: "",
        type: "",
        sorting: "",
        skipCount: 0,
        maxResultCount: 999,
      };
      let query = "";
      for (var key in params) {
        if (params[key] !== null && params[key] !== "") {
          if (
            key == "posts"
          ) {
            params[key].forEach((element) => {
              query = `${key}=${element}&${query}`;
            });
          } else {
            query = `${key}=${params[key]}&${query}`;
          }
        }
      }
      getUsersSearch(query).then(res => {
        this.getUserLoading = false;
        this.userList = res.result.items;
      })
    },
    // 获取公司
    getCompany(e) {
      this.getCompanyLoading = true;
      var params = {
        filter: e,
        condition: "Name",
        timeCondition: "",
        startTime: "",
        endTime: "",
        status: "",
        type: "",
        sorting: "",
        skipCount: 0,
        maxResultCount: 999,
      };
      getCompaniesSearch(params).then(res => {
        this.getCompanyLoading = false;
        this.companyList = res.result.items;
      })
    },
    //设置默认字段显示值
    getEnumValue(res) {
      res.result.typeVal = res.result.type; //存储展示用
      res.result.statusVal = res.result.status; //存储展示用
      res.result.paymentTypeVal = res.result.paymentType; //存储展示用
      res.result.type = getEnumMetaValue(this.$store.getters.enumMetadata, 'CompanyStoreType', res.result.type); //获取英文
      res.result.status = getEnumMetaValue(this.$store.getters.enumMetadata, 'CompanyStoreStatus', res.result.status); //获取英文
      res.result.paymentType = getEnumMetaValue(this.$store.getters.enumMetadata, 'CompanyStorePaymentType', res.result.paymentType); //获取英文
    },
    //控制显示/隐藏字段
    authLook(key) {
      this.hideInfo[key] = !this.hideInfo[key];
    },
    //更新分销商门店
    updateCompanyStore() {
      var formData = new FormData();
      formData.append("CompanyStore", JSON.stringify(this.companyStore));
      if (JSON.stringify(this.photoFile) != "{}") {
        formData.append("PhotoFile", this.photoFile);
      }
      updateCompanyStore(this.$route.params.id, formData).then(res => {
        if (res.code == 10200) {
          this.getEnumValue(res); //设置默认字段显示值
          this.companyStore = res.result;
          this.cancel();
          this.$message.success({
            message: "修改分销商门店成功",
            showClose: true
          });
          this.getCompanyStoreDetail()
        }
      });
    },
    //通过分销商门店标识获取详细信息
    getCompanyStoreDetail() {
      getCompanyStoreDetail(this.$route.params.id).then(res => {
        this.loading = false;
        this.getEnumValue(res); //设置默认字段显示值
        this.companyStore = res.result;
        this.companyStore.organizationId = res.result.organization?res.result.organization.id:'';
        this.companyStore.userId = res.result.user?res.result.user.id:'';
        //获取远程搜索的内容
        this.getOrganization();
      }).catch(()=>{
        this.loading = false;
      })
    },

    //添加备注
    editRemarks() {
      this.isRemarkShow = true;
      this.remarkForm.more = deepCopy(this.companyStore.more);
    },
    submitRemark() {
      this.isRemarkShow = false;
      this.companyStore.more = this.remarkForm.more;
      this.isRemarkChange = true;
      this.updateCompanyStore();
    },
    //添加标签
    addTag() {
      this.isTagsShow = false;
    },
    delTag(index) {
      this.companyStore.tags.splice(index, 1);
    },
    // 保存标签
    submitTag(isEnter) {
      if (this.headTag) {
        this.companyStore.tags.push(this.headTag);
        this.headTag = "";
      }
      if (!isEnter) {
        this.isTagChange = true;
        this.isTagsShow = true;
        this.updateCompanyStore();
      }
    },
    // 保存
    submit() {
      this.$refs.companyStoreForm.validate((valid) => {
        if (valid) {
          // 加盟合同生效时间不得大于结束时间
          if (this.companyStore.contractStartTime && this.companyStore.contractEndTime && this.companyStore.contractStartTime > this.companyStore.contractEndTime) {
            this.$message.success({
              message: "加盟合同生效时间不得大于结束时间",
              showClose: true
            });
            return;
          }
          // 特费缴费开始结束时间
          if (this.companyStore.paymentStartTime && this.companyStore.paymentEndTime && this.companyStore.paymentStartTime > this.companyStore.paymentEndTime) {
            this.$message.success({
              message: "特费缴费开始时间不得大于结束时间",
              showClose: true
            });
            return;
          }
          this.updateCompanyStore();
        } else {
          return false;
        }
      });
    },
    // 取消
    cancel() {
      this.isEditBasic = false;
      this.isEditDetail = false;
      this.isEditCharge = false;
    },
    // 获取分销商门店基础字段
    getCompanyStoreSettings() {
      getCompanyStoreSettings().then(res => {
        res.result.forEach(item => {
          switch (item.name) {
            case 'Deer.Company.Nature':
              break;
            case 'Deer.Company.RecruitWay':
              break;
            case 'Deer.Company.MaterialType': //资料附件类型
              break;
            case 'Deer.Company.EventType': //大事记类型
              break;
            case 'Deer.CompanyStore.Collection.DropWay': //分销商门店退出方式
              this.companyStoreDropWayOptions = item.value;
              break;
            case 'Deer.Company.Collection.MaterialType': //分销商门店资料附件类型
              break;
            case 'Deer.Company.Collection.EventType': //分销商门店大事记类型
              break;
          }
        });
      });
    },
    // 获取头像
    getFile(item) {
      this.photoFile = item.file;
      this.updateCompanyStore();
    },
    //图片大小
    beforeAvatarUpload(file) {
      const isPIC = file.type.indexOf("image") != -1;
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isPIC) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isPIC && isLt5M;
    },
    // 头部初始化
    headerInit() {
      let headerEl = document.querySelectorAll(".header-top");
      if (!headerEl[1] || !headerEl[1].style) {
        return;
      }
      headerEl[1].style.width = headerEl[0].offsetWidth + "px";
      document.querySelector(".scroll-box").style.width =
        document.querySelector(".basic-info").offsetWidth + "px";
      this.isHeaderInit = true;
    },
    // 头部滚动样式
    scrollScreen() {
      let el = document.querySelector(".edit-employe");
      this.scroll = el.scrollTop;
      if (this.scroll > 0) {
        this.isHeaderVisible = true;
      } else {
        this.isHeaderVisible = false;
      }
      if (this.scroll >= 25) {
        this.isHeaderShadow = true;
      } else {
        this.isHeaderShadow = false;
      }
      if (this.scroll >= 339) {
        this.isScrollShow = true;
      } else {
        this.isScrollShow = false;
      }
    },
  }
};